import usePopupState from '@swarm/core/hooks/state/usePopupState'
import { ExtendedSecurity } from '@swarm/types/normalized-entities'
import TokenIcon from '@swarm/ui/swarm/TokenIcon'
import { TokenSelectorModalProps } from '@swarm/ui/swarm/TokenSelector'
import TokenSelectorModal from '@swarm/ui/swarm/TokenSelector/TokenSelectorModal'
import { useCallback } from 'react'
import { Button, Flex, Icon, Loader, Text } from 'rimble-ui'
import styled from 'styled-components/macro'

const TokenButton = styled(Button.Text)`
  height: 32px;
  flex-shrink: 0;

  &:hover {
    text-decoration: none;
  }
`

interface SecuritySelectorProps
  extends TokenSelectorModalProps<ExtendedSecurity> {
  selected: ExtendedSecurity | null
  readonly: boolean
}

const SecuritySelector = ({
  loading,
  selected,
  onSelection,
  readonly,
  tokens,
  ...props
}: SecuritySelectorProps) => {
  const tokenSelectorModal = usePopupState(false)

  const handleSelection = useCallback(
    (token: ExtendedSecurity) => {
      onSelection(token)
      tokenSelectorModal.close()
    },
    [onSelection, tokenSelectorModal],
  )

  return (
    <>
      <TokenButton onClick={tokenSelectorModal.open} readonly={readonly}>
        {loading && <Loader m="auto" />}
        {!loading && selected && (
          <Flex alignItems="center">
            <TokenIcon symbol={selected?.symbol} width="33px" height="33px" />
            <Text color="black" ml={1} fontWeight={5}>
              {selected?.symbol.toLocaleUpperCase() || '--'}
            </Text>
            <Icon name="ExpandMore" />{' '}
          </Flex>
        )}
        {!loading && !selected}
      </TokenButton>
      {tokenSelectorModal.isOpen && (
        <TokenSelectorModal
          isOpen={tokenSelectorModal.isOpen}
          onClose={tokenSelectorModal.close}
          selected={selected}
          onSelection={handleSelection}
          tokens={tokens}
          loading={loading}
          {...props}
        />
      )}
    </>
  )
}

export default SecuritySelector
